import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { configureStore } from '@reduxjs/toolkit';
import adminConfigPageSlice from 'src/store/adminConfigPageSlice/adminConfigPageSlice';
import regionTasksConfigPageSlice from 'src/store/adminConfigPageSlice/regionTasksPageSlice/regionTasksPageSlice';
import siteConfigPageSlice from 'src/store/adminConfigPageSlice/siteConfigPageSlice/siteConfigPageSlice';
import taskConfigPageSlice from 'src/store/adminConfigPageSlice/taskConfigPageSlice/taskConfigPageSlice';
import correspondenceSlice from 'src/store/correspondenceSlice';
import createNewJobSlice from 'src/store/createNewJobSlice';
import defaultSettingsPageSlice from 'src/store/defaultSettingsPageSlice';
import emailDistributionPageSlice from 'src/store/emailDistributionPageSlice';
import errorBoundarySlice from 'src/store/errorBoundarySlice';
import jobConfigPageSlice from 'src/store/jobConfigPageSlice/jobConfigPageSlice';
import modificationsSlice from 'src/store/modificationsSlice';
import newJmrPageSlice from 'src/store/newJmrPageSlice/newJmrPageSlice';
import placementDetailsPageSlice from 'src/store/placementDetailsPageSlice/placementDetailsPageSlice';
import placementOverviewPageSlice from 'src/store/placementOverviewPageSlice';
import sitesSlice from 'src/store/siteSlice';
import toastsSlice from 'src/store/toastsSlice';
import updateShiftsSlice from 'src/store/updateShiftsPageSlice';
import updateSiteCapacitySlice from 'src/store/updateSiteCapacitySlice/updateSiteCapacitySlice';
import userSlice from 'src/store/userSlice';

export const reducers = {
  user: userSlice,
  sites: sitesSlice,
  defaultSettingsPage: defaultSettingsPageSlice,
  errorBoundary: errorBoundarySlice,
  toasts: toastsSlice,
  taskConfigPage: taskConfigPageSlice,
  siteConfigPage: siteConfigPageSlice,
  jobConfigPage: jobConfigPageSlice,
  createNewJobPage: createNewJobSlice,
  regionTasksConfigPage: regionTasksConfigPageSlice,
  adminConfigPage: adminConfigPageSlice,
  updateShiftsPage: updateShiftsSlice,
  emailDistributionPage: emailDistributionPageSlice,
  updateSiteCapacityPage: updateSiteCapacitySlice,
  placementOverviewPage: placementOverviewPageSlice,
  newJmrPage: newJmrPageSlice,
  placementDetailsPage: placementDetailsPageSlice,
  correspondence: correspondenceSlice,
  modifications: modificationsSlice,
};

const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // to allow non serializable objects to be stored in redux (eg: Map, Set, classes etc.)
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
